import List from "./components/List"
// import Button from "./components/Button"
import './App.css';
import Data from "./components/Data"
import Header from "./components/Header"



const tempArray = [
  {
    userId: 321,
    username: 'angieee3',
    date: 2,
    track: 'SWE',
    city: 'ATL',
    status: 'Received Questionnaire',
    statusDate: 'May 24',
    history: []

  },
  {
    userId: 322,
    username: 'Concentricities',
    date: 16,
    track: 'SWE',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 1',
    history: []
  },
  {
    userId: 323,
    username: 'Kiwi4844',
    date: 2,
    track: 'SWE',
    city: 'MLT',
    status: 'Received Questionnaire',
    statusDate: 'June 13',
    history: []
  },
  {
    userId: 324,
    username: 'Illustrious-Item3153',
    date: 13,
    track: 'SWE',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 325,
    username: 'UsefulMacaroon',
    date: 4,
    track: 'UX',
    city: 'NYC',
    status: 'Interviewing',
    statusDate: 'June 27',
    history: [{
      status: 'Received Questionnaire',
      date: "June 7"
    }]
  },

  {
    userId: 326,
    username: 'RecommendationOk8566',
    date: 16,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 327,
    username: 'NaturalRoundBrown',
    date: 16,
    track: 'UX',
    city: 'AUS',
    status: 'Received Questionnaire',
    statusDate: 'June 14',
    history: []

  },
  {
    userId: 328,
    username: 'kirbsdoods',
    date: 2,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []

  },
  {
    userId: 329,
    username: 'e92fromspace',
    date: 3,
    track: 'DM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 330,
    username: 'e92fromspace',
    date: 3,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 331,
    username: 'e92fromspace',
    date: 3,
    track: 'UX',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 332,
    username: 'Raylon22',
    date: 2,
    track: 'SWE',
    city: 'MLT',
    status: 'Received Questionnaire',
    statusDate: 'June 13',
    history: []
  },
  {
    userId: 333,
    username: 'Content-Charge1504',
    date: 3,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 334,
    username: 'Content-Charge1504',
    date: 3,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 335,
    username: 'Hot-Street-5955',
    date: 2,
    track: 'SWE',
    city: 'NYC',
    status: 'Interviewing',
    statusDate: '--',
    history: []
  },
  {
    userId: 336,
    username: 'necromandie',
    date: 15,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 337,
    username: 'necromandie',
    date: 11,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 338,
    username: 'necromandie',
    date: 15,
    track: 'IT',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 339,
    username: 'Hoshi_7',
    date: 2,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 340,
    username: 'joobilee',
    date: 2,
    track: 'SWE',
    city: 'MLT',
    status: 'Received Questionnaire',
    statusDate: 'June 15',
    history: []
  },
  {
    userId: 341,
    username: 'TotalEmployee2050',
    date: 16,
    track: 'DM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 342,
    username: 'mrsmeer',
    date: 2,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 343,
    username: 'mrsmeer',
    date: 2,
    track: 'DM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 344,
    username: 'Agreeable_Noise9169',
    date: 2,
    track: 'UX',
    city: 'MLT',
    status: 'Received Questionnaire',
    statusDate: 'June 14',
    history: [] //rejection July 1
  },
  {
    userId: 345,
    username: 'bleue_Nabi',
    date: 2,
    track: 'UX',
    city: 'AUS',
    status: 'Received Questionnaire',
    statusDate: 'June 7',
    history: []
  },

  {
    userId: 346,
    username: 'shrek2onblurayanddvd',
    date: 2,
    track: 'SWE',
    city: 'REM',
    status: 'Received Questionnaire',
    statusDate: 'June 15',
    history: []
  },
  {
    userId: 347,
    username: 'PhotographCareful963',
    date: 9,
    track: 'DM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 348,
    username: 'zzzalldayerrday',
    date: 2,
    track: 'UX',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 8',
    history: []
  },
  {
    userId: 349,
    username: 'zzzalldayerrday',
    date: 2,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 350,
    username: 'zzzalldayerrday',
    date: 2,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 351,
    username: 'smith5264',
    date: 2,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 352,
    username: 'Lyxn0',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 353,
    username: 'mindingmybizz',
    date: 2,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 354,
    username: 'Concentricities',
    date: 16,
    track: 'PM',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 1',
    history: []
  },
  {
    userId: 355,
    username: 'Concentricities',
    date: 16,
    track: 'UX',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 1',
    history: []
  },
  {
    userId: 356,
    username: 'Maleficent-Tooth-151',
    date: 16,
    track: 'UX',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 16',
    history: [] //rejection July 1
  },

  {
    userId: 357,
    username: 'SailorWisteria',
    date: 4,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 358,
    username: 'gendgaf',
    date: 2,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 359,
    username: 'gendgaf',
    date: 2,
    track: 'IT',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 360,
    username: 'gendgaf',
    date: 2,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 361,
    username: 'OneOperation6022',
    date: 2,
    track: 'SWE',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 362,
    username: 'OneOperation6022',
    date: 8,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 363,
    username: 'ACnatixo',
    date: 16,
    track: 'PM',
    city: 'MLT',
    status: 'Interviewing',
    statusDate: 'June 17',
    history: [{
      status: 'Received Questionnaire',
      date: "June 2"
    }]
  },

  {
    userId: 364,
    username: '_himynameismoose',
    date: 16,
    track: 'SWE',
    city: 'MLT',
    status: 'Received Questionnaire',
    statusDate: 'June 3',
    history: []
  },

  {
    userId: 365,
    username: 'Deeshyboo',
    date: 13,
    track: 'SWE',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 15',
    history: []
  },
  {
    userId: 366,
    username: 'Purple_Smurf',
    date: 16,
    track: 'IT',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 367,
    username: 'Purple_Smurf',
    date: 16,
    track: 'PM',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 368,
    username: 'Kmo_152313',
    date: 11,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 369,
    username: 'Kmo_152313',
    date: 11,
    track: 'DM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 370,
    username: 'Kmo_152313',
    date: 11,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 371,
    username: 'luna_xue',
    date: 16,
    track: 'DA',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 372,
    username: 'luna_xue',
    date: 16,
    track: 'DM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 373,
    username: 'TatiCeeFar',
    date: 2,
    track: 'SWE',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 374,
    username: 'consciousness_neur88',
    date: 16,
    track: 'DA',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 375,
    username: 'StarkRicochet',
    date: 10,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 376,
    username: 'StarkRicochet',
    date: 10,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 377,
    username: 'StarkRicochet',
    date: 10,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 378,
    username: 'WonderfulDraft9637',
    date: 5,
    track: 'PM', //applied MLT for PM
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 379,
    username: 'WonderfulDraft9637',
    date: 13,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 380,
    username: 'WonderfulDraft9637',
    date: 14,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 381,
    username: 'Jasminlee426',
    date: 2,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 382,
    username: 'Jasminlee426',
    date: 2,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 383,
    username: 'Jasminlee426',
    date: 2,
    track: 'DM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 384,
    username: 'Ok_Neck_6194',
    date: 8,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 385,
    username: 'MintyBry',
    date: 16,
    track: 'PM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 386,
    username: 'MintyBry',
    date: 16,
    track: 'UX',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 387,
    username: 'MintyBry',
    date: 16,
    track: 'SWE',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 388,
    username: 'Careless-Divide-416',
    date: 6,
    track: 'PM',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 389,
    username: 'mbsl2692',
    date: 16,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 390,
    username: 'xuxubreleza',
    date: 10,
    track: 'SWE',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 391,
    username: 'Txnhim',
    date: 16,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 392,
    username: 'Ambs8803',
    date: 2,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 393,
    username: 'itsamesomario',
    date: 15,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 394,
    username: 'itsamesomario',
    date: 16,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 395,
    username: 'stefffdot',
    date: 16,
    track: 'PM',
    city: 'MLT', //clarify
    status: 'Received Questionnaire',
    statusDate: 'June 4',
    history: []
  },
  {
    userId: 396,
    username: 'wesmellthecolor9',
    date: 16,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 397,
    username: 'wesmellthecolor9',
    date: 16,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 398,
    username: 'wesmellthecolor9',
    date: 16,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 399,
    username: 'KingMerc23',
    date: 14,
    track: 'SWE',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 400,
    username: 'rainbringer77',
    date: 2,
    track: 'DA',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 401,
    username: 'AliveIndependence309',
    date: 2,
    track: 'PM',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 13',
    history: []
  },

  {
    userId: 402,
    username: 'AliveIndependence309',
    date: 2,
    track: 'DA',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 15',
    history: []
  },
  {
    userId: 403,
    username: 'Realistic_Mulberry46',
    date: 9,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 404,
    username: 'Low-Ad2425',
    date: 2,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 405,
    username: 'Low-Ad2425',
    date: 2,
    track: 'DM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 406,
    username: 'CDY_JKR',
    date: 9,
    track: 'SWE',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 407,
    username: 'Pousheen',
    date: 16,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 408,
    username: 'CShmoney',
    date: 14,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 409,
    username: 'Sukkiii',
    date: 5,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 410,
    username: 'soliria',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 411,
    username: 'soliria',
    date: 2,
    track: 'DM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 412,
    username: 'ryanuts',
    date: 6,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 413,
    username: 'polach11',
    date: 15,
    track: 'SWE',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 414,
    username: 'ISometimeUseReddit',
    date: 2,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 415,
    username: 'Huskyowner2017',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 416,
    username: 'Huskyowner2017',
    date: 2,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 417,
    username: 'Huskyowner2017',
    date: 2,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 418,
    username: 'buyingbusiness',
    date: 15,
    track: 'DM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 419,
    username: 'buyingbusiness',
    date: 15,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 420,
    username: 'Automatic-Welcome-36',
    date: 8,
    track: 'DM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 421,
    username: 'TeamDifficult',
    date: 8,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 422,
    username: 'boomcheese44',
    date: 8,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 423,
    username: 'boomcheese44',
    date: 8,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 424,
    username: 'bigstemenergy',
    date: 16,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 425,
    username: 'bigstemenergy',
    date: 16,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 426,
    username: 'Icy_Lie_915',
    date: 15,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 427,
    username: 'OwnResearch9653',
    date: 2,
    track: 'DA',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 428,
    username: 'Holidate_List_6354',
    date: 12,
    track: 'DA',
    city: 'MLT',   //Austin, NYC
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 429,
    username: 'Alternative_Boot8878',
    date: 2,
    track: 'SWE',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 13',
    history: []
  },

  {
    userId: 430,
    username: 'milkteamarian',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 431,
    username: 'Apex-Legends-Gunch',
    date: 12,
    track: 'IT',
    city: 'AUS',
    status: 'Received Questionnaire',
    statusDate: 'June 6',
    history: []
  },


  {
    userId: 432,
    username: 'bobthewreckerr',
    date: 14,
    track: 'PM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 433,
    username: 'arliix',
    date: 4,
    track: 'SWE',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 434,
    username: 'Danielle-Dee',
    date: 6,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 435,
    username: 'Danielle-Dee',
    date: 16,
    track: 'DA',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 436,
    username: 'Danielle-Dee',
    date: 16,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 437,
    username: 'Stunning_Host9861',
    date: 6,
    track: 'DA',
    city: 'MLT',   //AUS, CHI, NYC
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  //

  {
    userId: 438,
    username: 'PitchesAintSheet',
    date: 16,
    track: 'IT',
    city: 'AUS',
    status: 'Interviewing',
    statusDate: 'June 21',
    history: [{
      status: 'Received Questionnaire',
      date: "June 3"
    }]
  },

  {
    userId: 439,
    username: 'PitchesAintSheet',
    date: 16,
    track: 'SWE',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 440,
    username: 'PitchesAintSheet',
    date: 16,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 441,
    username: 'jax422',
    date: 2,
    track: 'UX',
    city: 'MLT',  // NY, AUS, REM JAX
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 442,
    username: 'Practical_College472',
    date: 13,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 443,
    username: 'Practical_College472',
    date: 13,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 444,
    username: 'Practical_College472',
    date: 13,
    track: 'UX',
    city: 'NYC',  //& REMOTE
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 445,
    username: 'PlantLover_1',
    date: 15,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 446,
    username: 'aahhriana',
    date: 2,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 447,
    username: 'Glass_Composer_6695',
    date: 3,
    track: 'DA',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 448,
    username: 'Glass_Composer_6695',
    date: 3,
    track: 'SWE',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 449,
    username: 'Z_Sunflower',
    date: 15,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 450,
    username: 'Z_Sunflower',
    date: 15,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 451,
    username: 'Visual-Cantaloupe-74',
    date: 5,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 452,
    username: 'Chance_Border_6084',
    date: 9,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 453,
    username: 'Caymi0626',
    date: 15,
    track: 'DM',
    city: 'MLT',  //NYC , AUS, ATL 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 454,
    username: 'Caymi0626',
    date: 15,
    track: 'DA',
    city: 'MLT',  //NYC , AUS, ATL 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 455,
    username: 'Caymi0626',
    date: 15,
    track: 'PM',
    city: 'MLT',  //NYC , AUS, ATL 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 456,
    username: 'j-sauce96',
    date: 3,
    track: 'UX',
    city: 'MLT',  //NYC , AUS, REM 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 457,
    username: 'Valuable-Dog-46',
    date: 6,
    track: 'DA',
    city: 'AUS',
    status: 'Received Questionnaire',
    statusDate: 'Aug 10',
    history: []
  },

  {
    userId: 458,
    username: 'Valuable-Dog-46',
    date: 6,
    track: 'SWE',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 459,
    username: 'Valuable-Dog-46',
    date: 6,
    track: 'DM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 460,
    username: 'leorisingthrowaway',
    date: 15,
    track: 'SWE',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 461,
    username: 'leorisingthrowaway',
    date: 15,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 462,
    username: 'pearis-',
    date: 2,
    track: 'UX',
    city: 'MLT',  //CHI, ATL, REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 463,
    username: 'pearis-',
    date: 2,
    track: 'PM',
    city: 'MLT',  //CHI, ATL, REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 464,
    username: 'pearis-',
    date: 2,
    track: 'DA',
    city: 'MLT',  //CHI, ATL, REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 465,
    username: 'Comfortable-Wave-675',
    date: 4,
    track: 'DM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 466,
    username: 'Comfortable-Wave-675',
    date: 5,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 467,
    username: 'No-Physics6424',
    date: 15,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 468,
    username: 'wixposlav',
    date: 15,
    track: 'DA',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 469,
    username: 'Annonymouse535',
    date: 11,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 470,
    username: 'nv520',
    date: 12,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 471,
    username: 'nv520',
    date: 15,
    track: 'UX',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 472,
    username: 'Meowmehpls',
    date: 2,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 473,
    username: 'Meowmehpls',
    date: 2,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 474,
    username: 'monieva5',
    date: 15,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 475,
    username: 'monieva5',
    date: 15,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 476,
    username: 'itsreginalynn',
    date: 6,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 477,
    username: 'grantisrighteous2',
    date: 14,
    track: 'IT',
    city: 'MLT', //AUS, NYC
    status: 'Received Questionnaire', //rejection July 19
    statusDate: 'July 13',
    history: []
  },

  {
    userId: 478,
    username: 'Nervous_Importance98',
    date: 2,
    track: 'PM',
    city: 'MLT', //NYC, CHI
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 479,
    username: 'ro7sa3194',
    date: 2,
    track: 'UX',
    city: 'MLT', //NYC, AUS, REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 480,
    username: 'jjjcho',
    date: 2,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 481,
    username: 'jjjcho',
    date: 2,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 482,
    username: 'jjjcho',
    date: 2,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 483,
    username: 'Character-Tangelo-76',
    date: 2,
    track: 'DA',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 484,
    username: 'Realistic_Mulberry46',
    date: 9,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 485,
    username: 'Responsible_Mode_506',
    date: 15,
    track: 'IT',
    city: 'AUS',
    status: 'Received Offer',
    statusDate: 'Aug 11',
    history: [{
      status: 'Received Questionnaire',
      date: "June 10"
    },
    {
      status: 'Interviewing',
      date: 'June 21',
    }]
  },

  {
    userId: 486,
    username: 'sky127865466754323', //marianna L
    date: 3,
    track: 'PM',
    city: 'MLT', //NYC ATL AUS sky
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 487,
    username: 'sky127865466754323',
    date: 3,
    track: 'UX',
    city: 'MLT', //NYC ATL AUS sky
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 488,
    username: 'dadekotopon',
    date: 10,
    track: 'PM',
    city: 'MLT', //ATL NYC REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 489,
    username: 'ManCalledWest',
    date: 16,
    track: 'SWE',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 490,
    username: 'ManCalledWest',
    date: 16,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 491,
    username: 'sky127865466754323',
    date: 3,
    track: 'DM',
    city: 'MLT', //NYC ATL AUS sky
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 492,
    username: 'a1sol',
    date: 16,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 493,
    username: 'Aiimiiboo',
    date: 15,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 494,
    username: 'Readyplayer1x',
    date: 16,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 495,
    username: 'droppingtheeaves',
    date: 11,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 496,
    username: 'jiyooonah',
    date: 2,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 497,
    username: 'msezng',
    date: 2,
    track: 'SWE',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 498,
    username: 'Dull-Distribution214',
    date: 2,
    track: 'SWE',
    city: 'MLT', //AUS, NYC, REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 499,
    username: 'Dull-Distribution214',
    date: 2,
    track: 'PM',
    city: 'MLT', //AUS, NYC, REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 500,
    username: 'One-Fun-1195',
    date: 2,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 501,
    username: 'One-Fun-1195',
    date: 2,
    track: 'DA',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 502,
    username: 'GigaGochu',
    date: 16,
    track: 'SWE',
    city: 'MLT', //ALL
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 503,
    username: 'ken2566',
    date: 2,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 504,
    username: 'ken2566',
    date: 2,
    track: 'DM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 505,
    username: 'ken2566',
    date: 13,
    track: 'SWE',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 506,
    username: 'forde_e',
    date: 5,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 507,
    username: 'TinoBambinoo',
    date: 11,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 508,
    username: 'TinoBambinoo',
    date: 12,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 509,
    username: 'maddfio',
    date: 16,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 510,
    username: '12345_may',
    date: 8,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 511,
    username: 'k9cataclysm',
    date: 16,
    track: 'SWE',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 512,
    username: 'Affectionate_Food_72',
    date: 2,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 513,
    username: 'Keieiusus', //KAYLA
    date: 2,
    track: 'UX',
    city: 'MLT', //NYC, AUS, REM 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 514,
    username: 'Keieiusus', //KAYLA
    date: 2,
    track: 'DA',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 515,
    username: 'Keieiusus', //KAYLA
    date: 2,
    track: 'IT',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 516,
    username: 'Useful_Two6115',
    date: 2,
    track: 'PM',
    city: 'MLT',  //AUS ATL NYC CHI REM 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 517,
    username: 'alisonmcorreia',
    date: 3,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 518,
    username: 'alisonmcorreia',
    date: 3,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 519,
    username: 'alisonmcorreia',
    date: 3,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 520,
    username: 'PhilosophyUnique9491',
    date: 2,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 521,
    username: 'onlyraspberry',
    date: 10,
    track: 'PM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 522,
    username: 'onlyraspberry',
    date: 10,
    track: 'DM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 523,
    username: 'Frosty-Photograph477',
    date: 3,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 524,
    username: 'anerdscreativity',
    date: 2,
    track: 'DM',
    city: 'MLT', //NYC, ATL, CHI  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 525,
    username: 'lovelylavenderchild',
    date: 2,
    track: 'DA',
    city: 'CHI',
    status: 'Received Questionnaire',
    statusDate: 'June 15',
    history: []
  },


  {
    userId: 526,
    username: 'Deep-Pilot-4546',
    date: 16,
    track: 'IT',
    city: 'MLT',
    status: 'Interviewing',
    statusDate: 'June 21',
    history: [{
      status: 'Received Questionnaire',
      date: "June 13"
    }]
  },


  {
    userId: 527,
    username: 'Far-Flamingo6502',
    date: 2,
    track: 'DM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 528,
    username: 'Key_Initiative1932',
    date: 9,
    track: 'DM',
    city: 'CHI',
    status: 'Interviewing',
    statusDate: 'June 23',
    history: [{
      status: 'Received Questionnaire',
      date: "June 10"
    }]
  },


  {
    userId: 529,
    username: 'CupcakeOwnz',
    date: 2,
    track: 'IT',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 530,
    username: 'Particular-Ad-7271', //POSTED THAT HE APPLIED on the 2nd, questionnaire june 10
    date: 13,    //is that one for DM (implied from prev user's comment or ...)
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 531,
    username: 'Affectionate-Sun6081',
    date: 16,
    track: 'SWE',
    city: 'MLT', //ALL
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 532,
    username: 'Affectionate-Sun6081',
    date: 16,
    track: 'IT',
    city: 'MLT', //ALL
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 533,
    username: 'ExerciseSpecialist62',
    date: 5,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 534,
    username: 'shibuuyah',
    date: 2,
    track: 'IT',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 535,
    username: 'PalpitationAnnual590',
    date: 15,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 536,
    username: 'PalpitationAnnual590',
    date: 15,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 537,
    username: 'PalpitationAnnual590',
    date: 15,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 538,
    username: 'Rocioiscool',
    date: 13,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 539,
    username: 'Rocioiscool',
    date: 16,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 540,
    username: 'Rocioiscool',
    date: 16,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 541,
    username: 'smith5264',
    date: 2,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },
  {
    userId: 542,
    username: 'jstbecool',
    date: 6,
    track: 'DM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 543,
    username: 'jstbecool',
    date: 6,
    track: 'PM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 544,
    username: 'pandacatbear',
    date: 11,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 545,
    username: 'Double-Resident2578',
    date: 4,
    track: 'SWE',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 546,
    username: 'Double-Resident2578',
    date: 4,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 547,
    username: 'polach11',
    date: 15,
    track: 'SWE',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 548,
    username: 'Dukebrooklyn10',
    date: 9,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 549,
    username: 'annoyedfoxpower',
    date: 13,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 550,
    username: 'annoyedfoxpower',
    date: 13,
    track: 'DM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 551,
    username: 'No-Masterpiece-397',
    date: 2,
    track: 'SWE',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 13',
    history: []
  },

  {
    userId: 552,
    username: 'AwayInvestigator2355',
    date: 11,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 553,
    username: 'CorrinaCorrina1997',
    date: 10,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 554,
    username: 'CorrinaCorrina1997',
    date: 10,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 555,
    username: 'swarloswarlesbarkley',
    date: 6,
    track: 'IT',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 556,
    username: 'swarloswarlesbarkley',
    date: 15,
    track: 'PM',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 557,
    username: 'Double-Resident2578',
    date: 4,
    track: 'SWE',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 558,
    username: 'Double-Resident2578',
    date: 4,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 559,
    username: 'ms_obscene',
    date: 15,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 560,
    username: 'Kindapissed_70',
    date: 8,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 561,
    username: 'Kindapissed_70',
    date: 9,
    track: 'DM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 562,
    username: 'marech05',
    date: 2,
    track: 'SWE',
    city: 'NYC',
    status: 'Interviewing',
    statusDate: 'June 22',
    history: [{
      status: 'Received Questionnaire',
      date: "--"
    }]
  },

  {
    userId: 563,
    username: 'PhotographCareful963',
    date: 9,
    track: 'DM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 564,
    username: 'cozymatcha',
    date: 11,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 565,
    username: 'Phiasophy1006',
    date: 2,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 566,
    username: 'Phiasophy1006',
    date: 2,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 567,
    username: 'Phiasophy1006',
    date: 4,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 568,
    username: 'cutcarter',
    date: 15,
    track: 'PM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 569,
    username: 'namelessID',
    date: 2,
    track: 'SWE',
    city: 'REM',
    status: 'Received Offer',
    statusDate: 'Aug 18',
    history: [{
      status: 'Received Questionnaire',
      date: "June 10"
    },
    {
      status: 'Interviewing',
      date: "June 22"
    }]
  },


  {
    userId: 570,
    username: 'nutinmybutt17', //Paris
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 571,
    username: 'sirmaria01',
    date: 15,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 572,
    username: 'pogoda101',
    date: 16,
    track: 'SWE',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 573,
    username: 'nightln',
    date: 3,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 574,
    username: 'sociocoder',
    date: 10,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 575,
    username: 'sociocoder',
    date: 10,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 576,
    username: 'ChristmasTofu',
    date: 16,
    track: 'SWE',
    city: 'MLT', //NOT LISTED
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 577,
    username: 'ChristmasTofu',
    date: 16,
    track: 'DA',
    city: 'MLT', //NOT LISTED
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 578,
    username: 'Timely-Cat-273',
    date: 16,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 579,
    username: 'esiressa',
    date: 3,
    track: 'SWE',
    city: 'MLT', //NYC  AUS ATL REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 580,
    username: 'esiressa',
    date: 5,
    track: 'IT',
    city: 'MLT', //NYC  AUS 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 581,
    username: 'esiressa',
    date: 6,
    track: 'DA',
    city: 'MLT', //NYC  AUS 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 582,
    username: 'eggqueenn',
    date: 2,
    track: 'SWE',
    city: 'MLT', //UNK 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 583,
    username: 'royaljawn_',
    date: 2,
    track: 'IT',
    city: 'MLT', //UNK 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 584,
    username: 'royaljawn_',
    date: 2,
    track: 'PM',
    city: 'MLT', //UNK 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 585,
    username: 'royaljawn_',
    date: 2,
    track: 'DA',
    city: 'MLT', //UNK 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 586,
    username: 'Midnight_trainwrek1',
    date: 2,
    track: 'DA',
    city: 'MLT', //CHI AUS
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 587,
    username: 'Midnight_trainwrek1',
    date: 2,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 588,
    username: 'JJCookieMonster',
    date: 4,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 589,
    username: 'Radiant-Thing9009',
    date: 2,
    track: 'SWE',
    city: 'REM',
    status: 'Received Offer',
    statusDate: 'Aug 12',
    history: [{
      status: 'Received Questionnaire',
      date: "June 29"
    },
    {
      status: 'Interviewing',
      date: 'June 29', //interviewed July 15
    }]

    // status: 'Received Questionnaire',
    // statusDate: 'June 29',
    // history: []


  },

  {
    userId: 590,
    username: 'rogue1013',
    date: 3,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 591,
    username: 'Loveya1394',
    date: 15,
    track: 'UX',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 592,
    username: 'Loveya1394',
    date: 16,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 593,
    username: 'rogue1013',
    date: 3,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 594,
    username: 'yofavmoe',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 595,
    username: 'ilovebears',
    date: 15,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 596,
    username: 'SashaWestt',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Interviewing',
    statusDate: 'June 27', //interviewing jul 14
    history: [{
      status: 'Received Questionnaire',
      date: "June 10"
    }]
  },


  {
    userId: 597,
    username: 'ninthknight',
    date: 16,
    track: 'PM',
    city: 'AUS',
    status: 'Received Questionnaire',
    statusDate: 'July 28',
    history: []
  },

  {
    userId: 598,
    username: 'ninthknight',
    date: 16,
    track: 'SWE',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 599,
    username: 'Comfortable_House223',
    date: 13,
    track: 'UX',
    city: 'MLT', //AUS NYC REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 600,
    username: 'teestann',
    date: 3,
    track: 'PM',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 601,
    username: 'teestann', //Had a referral
    date: 3,
    track: 'SWE',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 602,
    username: 'teestann',
    date: 3,
    track: 'DA',
    city: 'MLT',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 603,
    username: 'internetatm',
    date: 5,
    track: 'SWE',
    city: 'ATL',
    status: 'Received Questionnaire',
    statusDate: '--',
    history: []

  },


  {
    userId: 604,
    username: 'Plastic_View4944',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 605,
    username: 'Trussell2001',
    date: 12,
    track: 'DM',
    city: 'MLT', //ATL CHI NYC 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 606,
    username: 'Trussell2001',
    date: 12,
    track: 'DA',
    city: 'MLT', //CHI AUS NYC
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 607,
    username: 'Trussell2001',
    date: 12,
    track: 'PM',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 608,
    username: 'skylighttyme',
    date: 3,
    track: 'PM',
    city: 'MLT', //ALL LOCATIONS
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 609,
    username: 'TechyTea',
    date: 3,
    track: 'SWE',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 610,
    username: 'TechyTea',
    date: 3,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 611,
    username: 'Ebbi538',
    date: 2,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 612,
    username: 'Ebbi538',
    date: 3,
    track: 'PM',
    city: 'MLT', //verify location
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 613,
    username: 'Hoppany19',
    date: 14,
    track: 'DA',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 614,
    username: 'Every_Dragonfruit171',
    date: 3,
    track: 'SWE',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 615,
    username: 'CraeZJae',
    date: 4,
    track: 'SWE',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 616,
    username: 'CraeZJae',
    date: 4,
    track: 'DA',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 617,
    username: 'milkteamarian',
    date: 2,
    track: 'DM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 618,
    username: 'Resident_Weeb',
    date: 2,
    track: 'PM',
    city: 'MLT',  //CHI AUS REM 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 619,
    username: 'Resident_Weeb',
    date: 2,
    track: 'UX',
    city: 'AUS',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 620,
    username: 'marysaaaa',
    date: 2,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 621,
    username: 'yowjav',
    date: 16,
    track: 'SWE',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 622,
    username: 'SweetNiq',
    date: 2,
    track: 'DM',
    city: 'ATL',
    status: 'Interviewing',
    statusDate: 'June 30',
    history: [{
      status: 'Received Questionnaire',
      date: "June 10"
    }]
  },


  {
    userId: 623,
    username: 'ShortyRock122',
    date: 16,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 624,
    username: 'ShortyRock122',
    date: 16,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 625,
    username: 'OthosOfficial',
    date: 16,
    track: 'SWE',
    city: 'CHI',  //REM  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 626,
    username: 'OthosOfficial',
    date: 16,
    track: 'UX',
    city: 'CHI',  //REM  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 627,
    username: 'Viddas25',
    date: 13,
    track: 'SWE',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 628,
    username: 'wiitle',
    date: 16,
    track: 'SWE',
    city: 'CHI', //REM   
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 629,
    username: 'Inspire-Growth-9123',
    date: 16,
    track: 'UX',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'June 27',
    history: []

  },


  {
    userId: 630,
    username: 'neylismaelin',
    date: 2,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 631,
    username: 'neylismaelin',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 632,
    username: 'amunoz8',
    date: 2,
    track: 'DM',
    city: 'MLT', //ALL  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 633,
    username: 'amunoz8',
    date: 2,
    track: 'SWE',
    city: 'MLT', //ALL  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },



  {
    userId: 634,
    username: 'Spirited_Sandwich_72',
    date: 10,
    track: 'PM',
    city: 'MLT', //ALL  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },



  {
    userId: 635,
    username: 'Alternative-Read-705',
    date: 15,
    track: 'PM',
    city: 'NYC', //REM  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 636,
    username: 'NPAUJVAJ',
    date: 10,
    track: 'PM',
    city: 'ATL', //REM  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 637,
    username: 'NPAUJVAJ',
    date: 10,
    track: 'SWE',
    city: 'ATL', //REM  
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 638,
    username: 'NPAUJVAJ',
    date: 10,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 639,
    username: 'Best-Career-9403',
    date: 16,
    track: 'PM',
    city: 'NYC',
    status: 'Received Offer',
    statusDate: 'Aug 15',
    history: [{
      status: 'Received Questionnaire',
      date: "June 10"
    },
    {
      status: 'Interviewing',
      date: "June 17"
    }]
  },


  {
    userId: 640,
    username: 'lovinlife3298',
    date: 11,
    track: 'DA',
    city: 'ATL', //REM 
    status: 'Received Questionnaire',
    statusDate: '--',
    history: []
  },

  {
    userId: 641,
    username: 'lovinlife3298',
    date: 11,
    track: 'DM',
    city: 'ATL', //REM 
    status: 'Received Questionnaire',
    statusDate: '--',
    history: []
  },


  {
    userId: 642,
    username: 'SocietyOk1116',
    date: 16,
    track: 'DA',
    city: 'AUS', //UNK
    status: 'Received Offer',
    statusDate: 'Aug 10',
    history: [{
      status: 'Received Questionnaire',
      date: "June 15"
    },
    {
      status: 'Interviewing',
      date: "June 21"
    }]
  },


  {
    userId: 643,
    username: 'KindheartednessGold2',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 644,
    username: 'tm32004',
    date: 2,
    track: 'UX',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 645,
    username: 'tm32004',
    date: 9,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 646,
    username: 'Apprehensive-Fee704',
    date: 8,
    track: 'DA',
    city: 'MLT', //UNK 
    status: 'Interviewing',
    statusDate: 'July 12',
    history: [{
      status: 'Received Questionnaire',
      date: "June 15"
    }]

    // status: 'Received Questionnaire', 
    // statusDate: 'June 15', 

  },


  {
    userId: 647,
    username: 'InvaderZimChin',
    date: 2,
    track: 'PM',
    city: 'MLT', //NYC CA MD
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 648,
    username: 'InvaderZimChin',
    date: 3,
    track: 'UX',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 649,
    username: 'sunintaurus-',
    date: 2,
    track: 'DA',
    city: 'MLT', //UNK
    status: 'Interviewing',
    statusDate: 'June 16',
    history: [{
      status: 'Received Questionnaire',
      date: "June 7"
    }]
  },


  {
    userId: 650,
    username: 'sunintaurus-',
    date: 2,
    track: 'DM',
    city: 'MLT', //UNK 
    status: 'Received Questionnaire',
    statusDate: 'June 6',
    history: []
  },


  {
    userId: 651,
    username: 'sunintaurus-',
    date: 2,
    track: 'PM',
    city: 'MLT', //UNK 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 652,
    username: 'ige_mo',
    date: 16,
    track: 'PM',
    city: 'MLT', //UNK 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },



  {
    userId: 653,
    username: 'Due_Excitement_8468',
    date: 12,
    track: 'UX',
    city: 'MLT', //UNK 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 654,
    username: 'No-Acanthisitta-4679',
    date: 4,
    track: 'PM',
    city: 'MLT', //AUS CHI NYC
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 655,
    username: 'bee_gurl735',
    date: 15,
    track: 'PM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 656,
    username: 'bee_gurl735',
    date: 15,
    track: 'DM',
    city: 'CHI',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 657,
    username: 'Zealousideal-Hunt355',
    date: 11,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 658,
    username: 'Zealousideal-Hunt355',
    date: 11,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 659,
    username: 'Zealousideal-Hunt355',
    date: 11,
    track: 'DA',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'July 8',
    history: []
  },


  {
    userId: 660,
    username: 'pandasimpa',
    date: 2,
    track: 'IT',
    city: 'AUS',
    status: 'Received Questionnaire',
    statusDate: 'July 13',
    history: []
  },


  {
    userId: 661,
    username: 'sreypechan',
    date: 2,
    track: 'PM',
    city: 'MLT', //ALL
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 662,
    username: 'sreypechan',
    date: 2,
    track: 'IT',
    city: 'MLT', //ALL
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 663,
    username: 'sreypechan',
    date: 2,
    track: 'DA',
    city: 'MLT', //ALL
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 664,
    username: 'Blackgirlmagical',
    date: 2,
    track: 'DM',
    city: 'NYC',
    status: 'Received Offer',
    statusDate: 'Aug 16',
    history: [{
      status: 'Received Questionnaire',
      date: "June 28"
    },
    {
      status: 'Interviewing',
      date: "--"
    }
    ]
    //status: 'Received Questionnaire', 
    //statusDate: 'June 28', 

  },


  {
    userId: 665,
    username: 'mbak1234',
    date: 16,
    track: 'DA',
    city: 'MLT', //NYC AUST
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 667,
    username: 'nmsalas',
    date: 14,
    track: 'IT',
    city: 'MLT', //AUS NYC 
    status: 'Received Questionnaire',
    statusDate: 'July 13',
    history: []
  },

  {
    userId: 668,
    username: 'joobilee',
    date: 2,
    track: 'IT',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'July 14',
    history: []
  },


  {
    userId: 669,
    username: 'jampckd',
    date: 14,
    track: 'SWE',
    city: 'REM', //REM LA
    status: 'Received Questionnaire',
    statusDate: 'July 14',
    history: []
  },


  {
    userId: 670,
    username: 'jampckd',
    date: 14,
    track: 'PM',
    city: 'REM', //REM LA
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 671,
    username: 'baoule_sama',
    date: 2,
    track: 'SWE',
    city: 'AUS',
    status: 'Received Questionnaire',
    statusDate: 'July 14',
    history: []
  },


  {
    userId: 672,
    username: 'Zealousideal-Pea6233',
    date: 8,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 673,
    username: 'Previous-Pain8400',
    date: 15,
    track: 'UX',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 674,
    username: 'dvrkihateu',
    date: 2,
    track: 'DA',
    city: 'CHI', //REM
    status: 'Received Questionnaire',
    statusDate: 'July 14',
    history: []
  },

  {
    userId: 675,
    username: 'Shishi2109',
    date: 2, //confirmed
    track: 'SWE',
    city: 'NYC', //REM
    status: 'Received Questionnaire',
    statusDate: 'July 15',
    history: []
  },


  {
    userId: 676,
    username: 'ikaymarra',
    date: 11,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 677,
    username: 'Previous_Audience_34',
    date: 13,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 678,
    username: 'SupermarketNice3119',
    date: 2,  //Apr 30
    track: 'SWE',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 679,
    username: 'SupermarketNice3119',
    date: 2,   //May 1
    track: 'DA',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 680,
    username: 'SupermarketNice3119',
    date: 2, //May 1
    track: 'IT',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 681,
    username: 'ParadigmSet',
    date: 16,
    track: 'DA',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 682,
    username: 'Techwithtosh',
    date: 11,
    track: 'DM',
    city: 'MLT', //ALL + REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 683,
    username: 'Techwithtosh',
    date: 11,
    track: 'UX',
    city: 'MLT', //ALL + REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 684,
    username: 'Techwithtosh',
    date: 11,
    track: 'PM',
    city: 'MLT', //ALL + REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 685,
    username: 'krispykremechicken',
    date: 16, //date is an approximation
    track: 'UX',
    city: 'CHI', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 686,
    username: 'krispykremechicken',
    date: 16,  //date is an approximation
    track: 'DM',
    city: 'CHI', //REM
    status: 'Received Offer',
    statusDate: 'Aug 16',
    history: [{
      status: 'Received Questionnaire',
      date: "July 10"
    },
    {
      status: 'Interviewing',
      date: "July 15"
    }
    ]
  },


  {
    userId: 687,
    username: 'omogal123',
    date: 3,
    track: 'DA',
    city: 'MLT', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 688,
    username: 'omogal123',
    date: 3,
    track: 'UX',
    city: 'MLT', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 689,
    username: 'omogal123',
    date: 3,
    track: 'PM',
    city: 'MLT', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 690,
    username: 'hyemike',
    date: 2,
    track: 'SWE',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 691,
    username: 'iiamkingnelson',
    date: 2,
    track: 'DA',
    city: 'CHI', //REM 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 692,
    username: 'iiamkingnelson',
    date: 2,
    track: 'PM',
    city: 'CHI', //REM 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 693,
    username: 'iiamkingnelson',
    date: 2,
    track: 'SWE',
    city: 'CHI', //REM 
    status: 'Received Questionnaire',
    statusDate: 'July 11',
    history: []
  },


  {
    userId: 694,
    username: 'Intelligent-Level-26',
    date: 16,
    track: 'DM',
    city: 'ATL',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 695,
    username: 'Dazzling_Ship4855',
    date: 15,
    track: 'DM',
    city: 'ATL', //REM 
    status: 'Received Questionnaire',
    statusDate: 'July 18',
    history: []
  },


  {
    userId: 696,
    username: 'fountainofEUTH',
    date: 6,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 697,
    username: 'RegisterNo6453',
    date: 2,
    track: 'UX',
    city: 'NYC', //REM 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 698,
    username: 'RegisterNo6453',
    date: 2,
    track: 'PM',
    city: 'NYC', //REM 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 699,
    username: 'RegisterNo6453',
    date: 2,
    track: 'DM',
    city: 'NYC', //REM 
    status: 'Received Questionnaire',
    statusDate: 'July 19',
    history: []
  },


  {
    userId: 700,
    username: 'ErsoRoot',
    date: 15,
    track: 'PM',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 701,
    username: 'ErsoRoot',
    date: 15,
    track: 'SWE',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 702,
    username: 'ErsoRoot',
    date: 15,
    track: 'IT',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 703,
    username: 'Beep_bop288',
    date: 16,
    track: 'PM',
    city: 'MLT', //ALL
    status: 'Received Questionnaire',
    statusDate: 'July 19',
    history: []
  },


  {
    userId: 704,
    username: 'Environmental-Belt30',
    date: 13,
    track: 'DM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },



  {
    userId: 705,
    username: 'Environmental-Belt30',
    date: 13,
    track: 'PM',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'July 19',
    history: []
  },


  {
    userId: 706,
    username: 'AdministrativeWash49',
    date: 3,
    track: 'PM',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 707,
    username: 'Ambitious-Citron739',
    date: 9,
    track: 'UX',
    city: 'MLT', //NO PREF
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 708,
    username: 'deri1258',
    date: 16,
    track: 'PM',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 709,
    username: 'deri1258',
    date: 16,
    track: 'DM',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 710,
    username: 'deri1258',
    date: 16,
    track: 'DA',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 711,
    username: 'juice_cruise',
    date: 16,
    track: 'SWE',
    city: 'CHI',
    status: 'Received Questionnaire',
    statusDate: 'July 27',
    history: []
  },


  {
    userId: 712,
    username: 'delpinoivivas',
    date: 11,
    track: 'SWE',
    city: 'CHI', //REM
    status: 'Received Questionnaire',
    statusDate: 'July 27',
    history: []
  },


  {
    userId: 713,
    username: 'junefromneptune',
    date: 3,
    track: 'SWE',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'July 27',
    history: []
  },


  {
    userId: 714,
    username: 'No-Bath-4653',
    date: 16,
    track: 'IT',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'July 26',
    history: []
  },


  {
    userId: 715,
    username: 'LocalFig6153',
    date: 16,
    track: 'DM',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 716,
    username: 'LocalFig6153',
    date: 16,
    track: 'SWE',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 717,
    username: 'LocalFig6153',
    date: 16,
    track: 'IT',
    city: 'NYC', //REM
    status: 'Received Questionnaire',
    statusDate: 'July 26',
    history: []
  },

  {
    userId: 718,
    username: 'delpinoivivas',
    date: 11,
    track: 'DA',
    city: 'CHI', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 719,
    username: 'Aggressive_Pizza_244',
    date: 4,
    track: 'SWE',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'July 26',
    history: []
  },

  {
    userId: 720,
    username: 'FaithlessnessFar3127',
    date: 2,
    track: 'PM',
    city: 'REM',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 721,
    username: 'Moltak1',
    date: 11,
    track: 'IT',
    city: 'MLT', //AUS NYC 
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

  {
    userId: 722,
    username: 'Moltak1',
    date: 11,
    track: 'SWE',
    city: 'MLT', // NYC CHI AUS
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 723,
    username: 'Federal-Salamander42',
    date: 15,
    track: 'DM',
    city: 'MLT', // NYC ATL
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 724,
    username: 'Defiant_Ad_6216',
    date: 15,
    track: 'DM',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'Aug 08',
    history: []
  },


  {
    userId: 725,
    username: 'Ok-Past-2871',
    date: 9,
    track: 'SWE',
    city: 'MLT', // ATL AUS CHI
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 726,
    username: 'SmartTelevision8733',
    date: 2,
    track: 'PM',
    city: 'MLT',
    status: 'Received Offer',
    statusDate: 'Aug 15', //interviewed 8/4 
    history: [{
      status: 'Received Questionnaire',
      date: "July 19"
    },
    {
      status: 'Interviewing',
      date: "July 28"
    },
    {
      status: 'Interviewed',
      date: "Aug 4"
    }]
  },



  {
    userId: 727,
    username: 'flapjackqueer', // for her boyfriend
    date: 2,
    track: 'DA',
    city: 'CHI',
    status: 'Received Offer',
    statusDate: 'Aug 10',
    history: [{
      status: 'Received Questionnaire',
      date: "--"
    },
    {
      status: 'Interviewing',
      date: "July 21"
    }]
  },


  {
    userId: 728,
    username: 'Real-Fly723',
    date: 2,
    track: 'SWE',
    city: 'CHI',
    status: 'Received Offer',
    statusDate: 'Aug 11',
    history: [{
      status: 'Received Questionnaire',
      date: "June 15"
    },
    {
      status: 'Interviewing',
      date: "June 22" //interviewed July 8
    }]
  },


  {
    userId: 729,
    username: 'IllustriousSource415',
    date: 2,
    track: 'DM',
    city: 'ATL',
    status: 'Received Offer',
    statusDate: 'Aug 12',
    history: [{
      status: 'Received Questionnaire',
      date: "--"
    },
    {
      status: 'Interviewing',
      date: "--"
    }]
  },


  {
    userId: 730,
    username: 'BrilliantAsk6631',
    date: 16,
    track: 'DM',
    city: 'NYC',
    status: 'Interviewing',
    statusDate: 'July 20', //interviewed 8/11 
    history: [{
      status: 'Received Questionnaire',
      date: "July 13"
    },
    {
      status: 'Interviewed',
      date: "Aug 11"
    }
    ]
  },

  {
    userId: 731,
    username: 'BrilliantAsk6631',
    date: 16,
    track: 'IT',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'July 13',  //rejected july 26
    history: []

  },


  {
    userId: 732,
    username: 'BrilliantAsk6631',
    date: 16,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 733,
    username: 'Galit_ie',
    date: 3,
    track: 'SWE',
    city: 'NYC',
    status: 'Received Questionnaire',
    statusDate: 'Aug 12',
    history: []

  },

  {
    userId: 734,
    username: 'Alternative_Big_7132',
    date: 13,
    track: 'DM',
    city: 'NYC',
    status: 'Received Offer',
    statusDate: 'Aug 15',
    history: [{
      status: 'Received Questionnaire',
      date: "June 13"
    },
    {
      status: 'Interviewing',
      date: "June 23"
    },
    {
      status: 'Interviewed', //decision monday --from comments section
      date: "July 7"
    }]
  },


  {
    userId: 735,
    username: 'CandidateOutrageous7',
    date: 2,
    track: 'DM',
    city: 'ATL', //UNK
    status: 'Received Offer',
    statusDate: 'Aug 12',
    history: [{
      status: 'Received Questionnaire',
      date: "June 2"
    },
    {
      status: 'Interviewing',
      date: "--"
    }]
  },


  {
    userId: 736,
    username: 'Spicy_viper137958',
    date: 15,
    track: 'UX',
    city: 'AUS', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 737,
    username: 'Intelligent_Creme143',
    date: 2,
    track: 'PM',
    city: 'ATL',
    status: 'Received Questionnaire',
    statusDate: 'Aug 16',
    history: []

  },


  {
    userId: 738,
    username: 'fonfon__ru',
    date: 2, //date unknown ???
    track: 'UX',
    city: 'NYC',
    status: 'Received Offer',
    statusDate: 'Aug 18',
    history: [{
      status: 'Received Questionnaire',
      date: "--"
    },
    {
      status: 'Interviewing',
      date: "--"
    }]

  },


  {
    userId: 739,
    username: 'notthemei',
    date: 2,
    track: 'UX',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 740,
    username: 'Educational_Cap777',
    date: 16,
    track: 'UX',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 741,
    username: 'PleasantAd8308',
    date: 2,
    track: 'UX',
    city: 'AUS', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 742,
    username: 'TheoClaudeS',
    date: 16,
    track: 'UX',
    city: 'MLT', //AUS NYC REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 743,
    username: 'Cultural-Carrot1237',
    date: 3,
    track: 'PM',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 744,
    username: '4HourDevz',
    date: 8,
    track: 'PM',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 745,
    username: 'No-Teaching9057',
    date: 2,
    track: 'UX',
    city: 'NYC',
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 746,
    username: 'No-Teaching9057',
    date: 3,
    track: 'DM',
    city: 'MLT', //NYC ATL CHI
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 747,
    username: 'No-Teaching9057',
    date: 3,
    track: 'PM',
    city: 'NYC', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 748,
    username: 'a_v_a_0047761',
    date: 3,
    track: 'UX',
    city: 'MLT', //UNK
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },


  {
    userId: 749,
    username: 'Wild_Form6553',
    date: 12,
    track: 'UX',
    city: 'AUS', //REM
    status: 'Submitted Application',
    statusDate: 'N/A',
    history: []
  },

]





function App() {
  return (
    <div className="app">
      <Header />
      {/* <Button /> */}
      <Data tempArray={tempArray} />
      <List tempArray={tempArray} />

    </div>
  );
}

export default App
